// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"styles_filterWrapper__1zTjH","filterBox":"styles_filterBox__1A_wJ","filterInput":"styles_filterInput__2sH_Q"};